import { A9Service, AbstractDataProviderV2 } from 'components/system';
import { RsOccupation } from 'common/customers/services/types/RsOccupation';
import { RsOccupationInfo } from 'common/customers/services/types/RsOccupationInfo';
import { OccupationAdd } from 'common/customers/services/types/OccupationAdd';
import { OccupationUpdate } from 'common/customers/services/types/OccupationUpdate';

@A9Service('customerOccupationDataProvider')
export class CustomerOccupationDataProvider extends AbstractDataProviderV2<RsOccupation, RsOccupationInfo, OccupationAdd, OccupationUpdate> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/occupations');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
